// Questions.js
import React from 'react';

//components
import { QuestionMain } from "../QuestionCommon";

const QuestionsPNOrders = (props) => {
  return (
    <div className="questions">
      <QuestionMain {...props} />
    </div>
  );
};

export default QuestionsPNOrders;